var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("li", { staticClass: "nav-item dropdown" }, [
    _c(
      "a",
      {
        staticClass: "nav-link count-indicator dropdown-toggle",
        attrs: {
          id: "notificationDropdown",
          href: "#",
          "data-toggle": "dropdown"
        }
      },
      [
        _c("i", {
          staticClass: "mdi mdi-bell-outline",
          class: { shaky: _vm.hasUnreadNotifications }
        }),
        _vm._v(" "),
        _vm.hasUnreadNotifications
          ? _c("span", { staticClass: "count-symbol bg-danger" })
          : _vm._e()
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass:
          "dropdown-menu dropdown-menu-right navbar-dropdown preview-list",
        attrs: { "aria-labelledby": "notificationDropdown" }
      },
      [
        _c("h6", { staticClass: "p-3 mb-0" }, [
          _vm._v(_vm._s(_vm.$t("pages.notifications.title")))
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "dropdown-divider" }),
        _vm._v(" "),
        _vm._l(_vm.notifications, function(notification) {
          return _c("div", [
            _c(
              "a",
              {
                staticClass: "dropdown-item preview-item",
                class: { read: _vm.hasBeenRead(notification) }
              },
              [
                _c("div", { staticClass: "preview-thumbnail" }, [
                  _c(
                    "div",
                    {
                      staticClass: "preview-icon",
                      class: notification.data.meta.type
                    },
                    [_c("i", { class: notification.data.meta.icon })]
                  )
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass:
                      "preview-item-content d-flex align-items-start flex-column justify-content-center",
                    on: {
                      click: function($event) {
                        return _vm.$router.push({ name: "notifications" })
                      }
                    }
                  },
                  [
                    _c(
                      "h6",
                      {
                        staticClass: "preview-subject font-weight-normal mb-1"
                      },
                      [_vm._v(_vm._s(notification.data.title))]
                    ),
                    _vm._v(" "),
                    _c("p", {
                      staticClass: "text-gray ellipsis mb-0",
                      domProps: { innerHTML: _vm._s(notification.data.text) }
                    }),
                    _vm._v(" "),
                    _c("small", { staticClass: "mt-2" }, [
                      _vm._v(
                        _vm._s(
                          _vm
                            .$date(notification.created_at)
                            .format("DD.MM.YYYY HH:mm")
                        )
                      )
                    ])
                  ]
                )
              ]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "dropdown-divider" })
          ])
        }),
        _vm._v(" "),
        !_vm.hasNotifications
          ? _c("a", { staticClass: "dropdown-item preview-item read" }, [
              _vm._m(0),
              _vm._v(" "),
              _vm._m(1)
            ])
          : _vm._e(),
        _vm._v(" "),
        _c(
          "router-link",
          {
            staticClass: "p-3 mb-0 text-center cursor-pointer",
            attrs: { tag: "h6", to: { name: "notifications" } }
          },
          [
            _vm._v(
              "\n            " +
                _vm._s(_vm.$t("pages.notifications.see_all")) +
                "\n        "
            )
          ]
        )
      ],
      2
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "preview-thumbnail" }, [
      _c("div", { staticClass: "preview-icon bg-dark" }, [
        _c("i", { staticClass: "mdi mdi-emoticon-happy" })
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass:
          "preview-item-content d-flex align-items-start flex-column justify-content-center"
      },
      [
        _c("h6", { staticClass: "preview-subject font-weight-normal mb-1" }, [
          _vm._v("No Notifications")
        ])
      ]
    )
  }
]
render._withStripped = true

export { render, staticRenderFns }